import React from 'react'
import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'
import { useState as uState, useEffect as uEffect } from 'react'
import './userPayment.css'
import { Link } from 'react-router-dom'

import QrCode from '../../assets/images/photo_6271811275310871311_y.jpg'

export default function userPayment() {
    const [data, setData] = uState([]);
    uEffect(() => {
        fetch("http://localhost:8000/order/orderPayment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => response.json()).then((data) => setData(data));
    }, []);
    const user = data.filter(product => product.hasOwnProperty('PaymentStatus'));
    return (
        <>
          <Navbar />
          <div className='conatiner-fluid text-center'>
                <h1>Payment GateWay</h1>
                {
                    user.map((item, index) => {
                        return (
                            <div className="card-header" key={index}>
                                <p>{index+1}</p>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">Email: {item.UserEmail}</li>
                                    <li className="list-group-item">Total Amount: {item.TotalAmount}</li>
                                    <li className="list-group-item">Payment Status: {item.PaymentStatus}</li>
                                </ul>
                            </div>
                        )
                    })
                }
                <div className='text-center container ' id="formpay" >

                    <form className="credit-card">
                        <div className="form-header">
                            <h4 className="title">Credit card detail</h4>
                        </div>

                        <div className="form-body">

                            <input type="text" className="card-number" placeholder="Card Number"/>


                                <div className="date-field">
                                    <div className="month">
                                        <select name="Month">
                                            <option value="january">January</option>
                                            <option value="february">February</option>
                                            <option value="march">March</option>
                                            <option value="april">April</option>
                                            <option value="may">May</option>
                                            <option value="june">June</option>
                                            <option value="july">July</option>
                                            <option value="august">August</option>
                                            <option value="september">September</option>
                                            <option value="october">October</option>
                                            <option value="november">November</option>
                                            <option value="december">December</option>
                                        </select>
                                    </div>
                                    <div className="year">
                                        <select name="Year">
                                            <option value="2016">2016</option>
                                            <option value="2017">2017</option>
                                            <option value="2018">2018</option>
                                            <option value="2019">2019</option>
                                            <option value="2020">2020</option>
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                            <option value="2024">2024</option>
                                        </select>
                                    </div>
                                </div>


                                <div className="card-verification">
                                    <div className="cvv-input">
                                        <input type="text" placeholder="CVV"/>
                                    </div>
                                    <div className="cvv-details">
                                        <p>3 or 4 digits usually found <br/> on the signature strip</p>
                                    </div>
                                </div>


                                <button type="submit" className="proceed-btn"><a href="#!">Proceed</a></button>
                                <button type="submit" className="paypal-btn"><a href="#!">Pay With UPI</a></button>
                        </div>
                    </form>
                </div>   
                <div className='container text-center'>
                    <Link to='/invoice' className='btn btn-success'>Download Invoice</Link>
                </div>

                    
                <div className='h1 text-center'>OR</div>
              <img width='400px' src={QrCode} alt=''/>
          </div>
          <Footer />
          
      </>
  )
}
